import type { FaireProductEntity } from "../../entity_types/product";

export const p_ch9vr3fnxe: FaireProductEntity = {
  token: "p_ch9vr3fnxe",
  type: "product",
  name: "Sanpellegrino Italian Sparkling Drink Chinotto, Sparkling Citrus Beverage, 4 Pack of 6.75 Fl Oz Bottles",
  brandToken: "b_vsezuurgak",
  brandName: "Made in eatalia",
  imageUrl:
    "https://cdn.faire.com/fastly/0fd17510df54247f7c1ccdb946bf0590288abb1a4cfd0fda0e4f9ca2b5e0f5d8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/27c0c0a6512f643287a103eddc9af3b353c5ae02c81687bedd3f6ff5cef7f487.jpeg",
    "https://cdn.faire.com/fastly/6290a37259cd2cb21d5e7b36b7534efb2d240e06011b0ba630cc6122d12a8217.jpeg",
    "https://cdn.faire.com/fastly/0c4b93665b2b8af30b54d56d2f55534ffab862d512d75679cbda47aaf5d44357.jpeg",
    "https://cdn.faire.com/fastly/84793cf953769cb54aa31072f10826d4a580c67620ad79e607d91a9080f2dcb6.jpeg",
    "https://cdn.faire.com/fastly/da6ab95af5459aae3f6366dcb0cbd16f89eed48fba4e5bbb763482ee6087881b.jpeg",
  ],
  priceDollars: 13.29,
  description:
    "\n\n\n * Includes four 6.75 fluid ounce glass bottles of Sanpellegrino Chinotto Italian Sparkling Drink. EBT item in eligible states \n * These Sanpellegrino Italian sparkling drinks are made with carbonated water, Chinotto orange extract, sugar and other natural flavors \n * Great for any time of day, whether you want a bubbly sparkling beverage in the morning, or a refreshing sparkling drink at the end of the day \n * This Sanpellegrino Italian sparkling drink offers fresh tasting flavor with no artificial sweeteners \n * Whatever the occasion, brighten up your moments with Sanpellegrino Italian sparkling drinks \n\n\nDetails: Enjoy every sparkling moment with Sanpellegrino Chinotto Sparkling Drink.",
  tags: [],
  msrpDollars: 16.61,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:37.439Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
